import { ScheduledRelayCommandConfig } from '@thingslog/repositories';
import { EventConfigFactory } from './EventConfigFactory';

export class ScheduledRelayCommandFactory implements EventConfigFactory {
  public create(deviceNumbers: string[]): ScheduledRelayCommandConfig {
    return {
      '@type': 'SCHEDULED_RELAY_COMMAND',
      deviceCommand: 'SCHEDULED_RELAY_COMMAND',
      deviceNumbers,
      relayIndex: 0,
      requiredState: 'OFF',
      hour: 0,
      minutes: 0,
    };
  }
}
